import styled from 'styled-components';

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const BadgeWrapper = styled.span<{ $background: string; $color: string; $border: string }>`
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizes.small};
  background-color: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  border: 1px solid ${({ $border }) => $border};
  border-radius: 8px;
  min-height: 23px;
  width: fit-content;
  padding: 4px 12px;
`;
